import { useAppSettingsService } from "src/services/appSettingsService/appSettingsService";
import { getSettings } from "src/services/configService";

export function useEnrollmentFlowEnabled(): boolean {
    const { effectiveWorkspaceSettings } = useAppSettingsService();
    const { features } = getSettings();

    if (features.enrollmentFlowEnabled) {
        // the new flow must always be reachable when the tenant allows it.
        return features.pages.enrollmentPageEnabled;
    } else {
        return effectiveWorkspaceSettings.isEnrollmentPageEnabled;
    }
}
